/**
 * Advanced filter definitions for the Payments module.
 * Same structure as InvoiceManagement/constants/filters.js, used by StatusFilter.
 */

export const PAYMENT_FILTER_DATA = [
  {
    title: "Payment Type",
    filter_key: "payment_type",
    type: "checkbox",
    filters: [
      { label: "Advance", value: "ADVANCE" },
      { label: "Running", value: "RUNNING" },
      { label: "Final", value: "FINAL" },
    ],
  },
  {
    title: "Overdue",
    filter_key: "overdue",
    type: "checkbox",
    filters: [{ label: "Overdue only", value: "true" }],
  },
  {
    title: "MSME",
    filter_key: "msme_breach",
    type: "checkbox",
    filters: [{ label: "MSME breach risk only", value: "true" }],
  },
];
